export type SearchSuggestEvent = {
  GA4: {
    event: 'search';
    action: 'search_suggest';
    label: string;
  };
};

export const trackSearchSuggest = ({searchTerm}: {searchTerm: string}) => {
  const eventGA4: SearchSuggestEvent['GA4'] = {
    event: 'search',
    action: 'search_suggest',
    label: searchTerm,
  };

  return {
    GA4: eventGA4,
  };
};
